import { styled } from '@mui/system'

const SwiperZoomContainer = styled('div')``
const SwiperZoomTarget = styled('div')`
	position: relative;
	width: 100%;
	height: auto;
	display: inline-block;
`

export { SwiperZoomContainer, SwiperZoomTarget }
